import { useEffect, useState } from "react";
import {
    generertokenserviceparprestataire,
    voirtokenserviceparprestataire,
} from "../../services/prestataires/service";
import { useTranslation } from 'react-i18next';

function AjoutTokenService(props) {
    const { t } = useTranslation();
    const [token, setToken] = useState(null);
    const [generatedToken, setGeneratedToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [copied, setCopied] = useState(false);

    const recupererToken = () => {
        setLoading(true);
        voirtokenserviceparprestataire(props.datas.id)
            .then((res) => {
                setToken(res.data.donnee.token);
            })
            .catch((error) => {
                setToken(null);
                console.log("ERROR ==>", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const genererClientToken = () => {
        setGenerating(true);
        const values = {
            serviceId: props.datas.id,
        };
        generertokenserviceparprestataire(values)
            .then((res) => {
                setToken(null);
                setGeneratedToken(res.data.donnee.token);
            })
            .catch((error) => {
                setGeneratedToken(null);
                console.log("ERROR ==>", error);
            })
            .finally(() => {
                setGenerating(false);
            });
    };

    const resetModal = () => {
        setToken(null);
        setGeneratedToken(null);
        setLoading(false);
        setGenerating(false);
        setCopied(false);
    };

    const copyToken = (tokenToCopy) => {
        navigator.clipboard.writeText(tokenToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    useEffect(() => {
        if (props.datas && props.datas.id) {
            recupererToken();
        }
    }, [props.datas]);

    useEffect(() => {
        const modalElement = document.getElementById("ajoutTokenService");
        const handleModalHidden = () => {
            resetModal();
        };
        const handleModalShown = () => {
            if (props.datas && props.datas.id) {
                recupererToken();
            }
        };

        modalElement?.addEventListener("hidden.bs.modal", handleModalHidden);
        modalElement?.addEventListener("shown.bs.modal", handleModalShown);

        return () => {
            modalElement?.removeEventListener("hidden.bs.modal", handleModalHidden);
            modalElement?.removeEventListener("shown.bs.modal", handleModalShown);
        };
    }, [props.datas]);

    return (
        <div
            className="modal fade"
            id="ajoutTokenService"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content blueSkanpay">
                    <div className="modal-header text-white">
                        <h5 className="modal-title" id="staticBackdropLabel">
                            {t('providers.tokenModal.title')}
                        </h5>
                        <button
                            type="button"
                            className="bg-danger btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body bg-white">
                        {loading && (
                            <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">{t('providers.tokenModal.loading')}</span>
                                </div>
                            </div>
                        )}

                        {!loading && !token && !generatedToken && (
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <p className="fw-bold text-center fs-5">
                                    {t('providers.tokenModal.generateMessage')}
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-md btn-primary"
                                    onClick={genererClientToken}
                                    disabled={generating}
                                >
                                    {generating ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            {t('providers.tokenModal.generating')}
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-key"></i> {t('providers.tokenModal.generateButton')}
                                        </>
                                    )}
                                </button>
                            </div>
                        )}

                        {!loading && !token && generatedToken && (
                            <div>
                                <div
                                    style={{ backgroundColor: "#ffe1e1" }}
                                    className="p-2 d-flex gap- rounded-3"
                                >
                                    <i
                                        style={{ color: "#c30000" }}
                                        className="fa fa-exclamation-circle m-1"
                                    ></i>
                                    <p style={{ color: "#c30000" }}>
                                        {t('providers.tokenModal.warningMessage')}
                                    </p>
                                </div>
                                <div className="mt-3">
                                    <p
                                        style={{ margin: 0, marginBottom: 5 }}
                                        className="fw-semibold fs-6"
                                    >
                                        {t('providers.tokenModal.yourToken')}
                                    </p>
                                    <div
                                        style={{ backgroundColor: "#e1e1e1ff", overflowX: "auto" }}
                                        className="p-2 rounded-3"
                                    >
                                        <p className="fw-bold text-center fs-6" style={{ whiteSpace: "nowrap", margin: 0 }}>
                                            {generatedToken}
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-2 d-flex justify-content-end align-items-center gap-2">
                                    {copied && (
                                        <span className="text-success fw-semibold">
                                            <i className="fa fa-check"></i> {t('providers.tokenModal.copied')}
                                        </span>
                                    )}
                                    <button
                                        type="button"
                                        className={`btn btn-sm ${copied ? "btn-success" : "btn-primary"}`}
                                        onClick={() => copyToken(generatedToken)}
                                    >
                                        <i className={`fa ${copied ? "fa-check" : "fa-copy"}`}></i> {copied ? t('providers.tokenModal.copyButton') : t('providers.tokenModal.copy')}
                                    </button>
                                </div>
                            </div>
                        )}

                        {!loading && token && !generatedToken && (
                            <div>
                                <div className="mt-3">
                                    <p
                                        style={{ margin: 0, marginBottom: 5 }}
                                        className="fw-semibold fs-6"
                                    >
                                        {t('providers.tokenModal.currentToken')}
                                    </p>
                                    <div
                                        style={{ backgroundColor: "#e1e1e1ff", overflowX: "auto" }}
                                        className="p-2 rounded-3"
                                    >
                                        <p className="fw-bold text-center fs-4" style={{ whiteSpace: "nowrap", margin: 0 }}>{token}</p>
                                    </div>
                                </div>
                                <div className="mt-2 d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary"
                                        onClick={genererClientToken}
                                        disabled={generating}
                                    >
                                        {generating ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                {t('providers.tokenModal.generating')}
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-key"></i> {t('providers.tokenModal.generateNewButton')}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AjoutTokenService;
